import PropTypes from 'prop-types';
import React from 'react';
import Config from '~/config';

const LIST_IMAGE = {
  designAc: [
    {
      url: '/search/building?page=1',
      image: `${Config.staticPrefix}/static/assets/image/header/silhouetteAC/0-01.jpg`,
    },
    {
      url: '/search/animal?page=1',
      image: `${Config.staticPrefix}/static/assets/image/header/silhouetteAC/0-02.jpg`,
    },
    {
      url: '/search/factory?page=1',
      image: `${Config.staticPrefix}/static/assets/image/header/silhouetteAC/0-03.jpg`,
    },
    {
      url: '/search/yoga?page=1',
      image: `${Config.staticPrefix}/static/assets/image/header/silhouetteAC/0-04.jpg`,
    },
    {
      url: '/search/bread?page=1',
      image: `${Config.staticPrefix}/static/assets/image/header/silhouetteAC/0-05.jpg`,
    },
    {
      url: '/search/rain?page=1',
      image: `${Config.staticPrefix}/static/assets/image/header/silhouetteAC/0-06.jpg`,
    },
  ],
  photoAC: [
    // {
    //   url: '/photo/22243',
    //   image: `${Config.staticPrefix}/static/assets/image/header/photoAC/0-01.jpg`,
    // },
    {
      url: '/photo/35884',
      image: `${Config.staticPrefix}/static/assets/image/header/photoAC/0-02.jpg`,
    },
    {
      url: '/photo/16355',
      image: `${Config.staticPrefix}/static/assets/image/header/photoAC/0-03.jpg`,
    },
    {
      url: '/photo/27442',
      image: `${Config.staticPrefix}/static/assets/image/header/photoAC/0-04.jpg`,
    },
    {
      url: '/photo/1283175',
      image: `${Config.staticPrefix}/static/assets/image/header/photoAC/0-05.jpg`,
    },
    // {
    //   url: '/photo/40431',
    //   image: `${Config.staticPrefix}/static/assets/image/header/photoAC/0-06.jpg`,
    // },
    {
      url: '/photo/27680',
      image: `${Config.staticPrefix}/static/assets/image/header/photoAC/0-07.jpg`,
    },
    // {
    //   url: '/photo/67649',
    //   image: `${Config.staticPrefix}/static/assets/image/header/photoAC/0-08.jpg`,
    // },
    // {
    //   url: '/photo/24666',
    //   image: `${Config.staticPrefix}/static/assets/image/header/photoAC/0-09.jpg`,
    // },
    // {
    //   url: '/photo/1005895',
    //   image: `${Config.staticPrefix}/static/assets/image/header/photoAC/0-10.jpg`,
    // },
    {
      url: '/photo/52832',
      image: `${Config.staticPrefix}/static/assets/image/header/photoAC/0-11.jpg`,
    },
    {
      url: '/photo/1153275',
      image: `${Config.staticPrefix}/static/assets/image/header/photoAC/0-12.jpg`,
    },
    {
      url: '/photo/14603',
      image: `${Config.staticPrefix}/static/assets/image/header/photoAC/0-13.jpg`,
    },
    {
      url: '/photo/465353',
      image: `${Config.staticPrefix}/static/assets/image/header/photoAC/0-14.jpg`,
    },
  ],
  silhouetteAC: [
    {
      url: '/search/building?page=1',
      image: `${Config.staticPrefix}/static/assets/image/header/silhouetteAC/0-01.jpg`,
    },
    {
      url: '/search/animal?page=1',
      image: `${Config.staticPrefix}/static/assets/image/header/silhouetteAC/0-02.jpg`,
    },
    {
      url: '/search/factory?page=1',
      image: `${Config.staticPrefix}/static/assets/image/header/silhouetteAC/0-03.jpg`,
    },
    {
      url: '/search/yoga?page=1',
      image: `${Config.staticPrefix}/static/assets/image/header/silhouetteAC/0-04.jpg`,
    },
    {
      url: '/search/bread?page=1',
      image: `${Config.staticPrefix}/static/assets/image/header/silhouetteAC/0-05.jpg`,
    },
    {
      url: '/search/rain?page=1',
      image: `${Config.staticPrefix}/static/assets/image/header/silhouetteAC/0-06.jpg`,
    },
  ],
  illustAC: [
    {
      url: '/search/Global%20Business',
      image: `${Config.staticPrefix}/static/assets/image/header/illustAC/0-02.jpg`,
    },
    {
      url: '',
      image: `${Config.staticPrefix}/static/assets/image/header/illustAC/0-03.jpg`,
    },
    {
      url: '/search/Real%20universe',
      image: `${Config.staticPrefix}/static/assets/image/header/illustAC/0-04.jpg`,
    },
    {
      url: '/search/yoga?orderBy=newest&page=1&per_page=100',
      image: `${Config.staticPrefix}/static/assets/image/header/illustAC/0-05.jpg`,
    },
  ],
};

class BackgroundRandomImgComponent extends React.Component {
  constructor(props) {
    super(props);
    this.images = this.getPhotoSite();
    this.number = this.random(0, this.images.length);
  }

  getPhotoSite() {
    switch (Config.serviceType) {
      case 'design_ac':
        return LIST_IMAGE.designAc;
      case 'photo_ac':
        return LIST_IMAGE.photoAC;
      case 'silhouette_ac':
        return LIST_IMAGE.silhouetteAC;
      case 'illust_ac':
        return LIST_IMAGE.illustAC;
    }
  }

  random(min = 0, max = 1) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  render() {
    const { number } = this;
    const { images } = this;
    const link = images[number].url;
    const randomImageURL = images[number].image;
    const { imageURL } = this.props;

    return (
      <>
        {link ? (
          <a href={link}>
            <div
              className={`${this.props.className} background-img`}
              style={{
                backgroundImage: `url(${imageURL || randomImageURL})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
              }}
            >
              {this.props.children}
            </div>
          </a>
        ) : (
          <div
            className={`${this.props.className} background-img`}
            style={{
              backgroundImage: `url(${imageURL || randomImageURL})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }}
          >
            {this.props.children}
          </div>
        )}
        <style jsx>
          {`
            .background-img .ant-table {
              font-size: 18px;
            }
          `}
        </style>
      </>
    );
  }
}

BackgroundRandomImgComponent.defaultProps = {
  className: '',
  url: '',
};
BackgroundRandomImgComponent.propTypes = {
  className: PropTypes.string,
  url: PropTypes.string,
};
export default BackgroundRandomImgComponent;
